import { useState } from "react";
import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { Breadcrumbs } from "@/components/site/Breadcrumbs";
import { pageHead } from "@/lib/seo";
import { truncateWords } from "@/lib/text";
import { listPosts, type PostCard } from "@/lib/blog.functions";


export const Route = createFileRoute("/blog")({
  loader: () => listPosts(),
  head: () =>
    pageHead({
      title: "Blog | Dr. Kelson Kawamura — Cirurgia Plástica em Foz",
      description:
        "Artigos do Dr. Kelson Kawamura sobre cirurgia plástica: indicações, preparo, pós-operatório e resultados naturais em Foz do Iguaçu.",
      path: "/blog",
    }),
  component: BlogIndex,
  errorComponent: () => (
    <SiteShell>
      <section className="kk-section">
        <div className="kk-container">
          <h1 className="kk-h2">Blog</h1>
          <p className="kk-lead">Não foi possível carregar os artigos agora. Tente novamente em instantes.</p>
        </div>
      </section>
    </SiteShell>
  ),
});

function fmt(date: string | null) {
  if (!date) return "";
  return new Date(date).toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" });
}

export function PostCardItem({ post }: { post: PostCard }) {
  return (
    <Link to="/$slug" params={{ slug: post.slug }} className="kk-post-card">
      <div className="kk-post-card__media">
        {post.cover_image_url ? (
          <img src={post.cover_image_url} alt={post.cover_image_alt || post.h1_title} loading="lazy" />
        ) : (
          <div className="kk-post-card__placeholder" aria-hidden="true" />
        )}
      </div>
      <div className="kk-post-card__body">
        {post.category ? <span className="kk-post-card__tag">{post.category.name}</span> : null}
        <h3>{post.h1_title}</h3>
        {post.excerpt ? <p>{truncateWords(post.excerpt, 15)}</p> : null}
        <span className="kk-post-card__date">{fmt(post.published_at)}</span>
      </div>
    </Link>
  );
}

function BlogIndex() {
  const { posts } = Route.useLoaderData() as { posts: PostCard[] };
  const [visible, setVisible] = useState(9);
  const shown = posts.slice(0, visible);

  return (
    <SiteShell>
      <div className="kk-page-top" />
      <Breadcrumbs items={[{ label: "Blog" }]} />
      <section className="kk-section">
        <div className="kk-container">
          <span className="kk-eyebrow">Conteúdo</span>
          <h1 className="kk-h2">Blog do Dr. Kelson Kawamura</h1>
          <p className="kk-lead">
            Informação clara e responsável sobre <strong>cirurgia plástica</strong>: indicações, preparo,
            pós-operatório e o que esperar de <strong>resultados naturais</strong>.
          </p>

          <h2 className="kk-h3" style={{ marginBottom: 24 }}>Artigos</h2>

          <div className="kk-post-grid">

            {shown.map((post) => (
              <PostCardItem key={post.slug} post={post} />
            ))}
          </div>

          {visible < posts.length ? (
            <div style={{ marginTop: 48, textAlign: "left" }}>
              <button type="button" className="kk-button-secondary" onClick={() => setVisible((v) => v + 3)}>
                Carregar mais artigos
              </button>
            </div>
          ) : null}
        </div>
      </section>
    </SiteShell>
  );
}

